import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: 'app-auxUrlBnup',
  templateUrl: './auxUrlBnup.component.html',
  styleUrls: ['./auxUrlBnup.component.css']
})
export class AuxUrlBnupComponent implements OnInit {

  constructor(private dialog: MatDialog, private _router:Router) { }
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
  ngOnInit(): void {
  }
abrirSeguimiento(){
  console.log('===ABRIR SEGUIMIENTO ====');
    this._router.navigate(['seguimiento_bnup']); 
}

abrirIngreso(){
  console.log('===ABRIR INGRESO ====');

  this._router.navigate(['/bnup']); 
  this.dialog.closeAll();

}
  
}
